import React from 'react';

import usePostsInfiniteQuery from '../../Hooks/usePostsInfiniteQuery';
import { PostVisibilities } from '../../Utils/Types';
import ListItems from './ListItems';
import useSpace from '../../Hooks/useSpace';

function Posts({ postsTypes, limit, queryOptions = {}, emptyState, post, ...rest }: any) {
  const { space } = useSpace();
  const { pages, postsCount, paging, isFetching, hasNextPage, fetchNextPage } =
    usePostsInfiniteQuery([postsTypes.join('-'), post?.id], {
      space,
      post,
      types: postsTypes,
      visibilities: [PostVisibilities.PUBLISHED],
      limit,
      sort: '-dates',
      ...queryOptions,
    });

  const showSkeleton = isFetching && !postsCount;
  const showEmptyState = postsCount === 0 && !showSkeleton;

  if (showEmptyState) {
    return emptyState || null;
  }

  return (
    <ListItems
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      paging={paging}
      pages={pages}
      showEmptyState={showEmptyState}
      showSkeleton={showSkeleton}
      space={space}
      postsCount={postsCount}
      {...rest}
    />
  );
}

export default Posts;
